import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import { operationalFunction } from 'components/UIBuilder/SectionFunction/Common';
import * as globalFunction from 'util/GlobalFunction';

export function manageExemptionPartialComplianceTemplateFolder({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.child.current?.setState({ manageFolderShow: true });
  setTimeout(() => {
    sectionComponent.child.current?.manageFolder.current?.getExemptionPartialComplianceTemplateFolderList();
  }, config.setTimeoutMilliSecond);
}

export function addExemptionPartialComplianceTemplate({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.setState({ showModal: true, componentType: 'Create' });
  setTimeout(() => {
    let formData = parameter;
    sectionComponent.customForm.current?.formRef.current?.setFieldsValue(formData);
    sectionComponent.customForm.current?.setState({ formData });
  }, config.setTimeoutMilliSecond);
}

export function collapseFolder({ component, key } = {}) {
  let data = component.state.data.map((folder, i) => {
    if (folder.key === key) {
      if (folder.Collapsed !== true) {
        folder.Collapsed = true;
      } else {
        folder.Collapsed = false;
      }
    }
    return folder;
  });
  component.setState({ data });
}
